import React from "react";
import ExcalidrawViewer from "../../components/ExcalidrawViewer";

const AustraliaF35Companies: React.FC = () => (
  <ExcalidrawViewer
    filePath="/excalidraw/australia-f35-companies.excalidraw"
    title="Australian F-35 Companies Supplying Parts to Israel"
    subtitle="70+ companies, A$4B+ in contracts, the supply chain route (Sydney > Bangkok > Nevatim Airbase), and documented parts from leaked shipping records"
  />
);

export default AustraliaF35Companies;
